export default {"src":"/_next/static/media/disc-types.35c92f2b.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};